import {
  ImgOfficers2,
  ImgOfficers5,
  ImgOfficers6,
  ImgSedeArequipa1,
  ImgSedeArequipa2,
  ImgSedeArequipa3,
  ImgSedeArequipa4,
  ImgSedeArequipa5,
  ImgSedeArequipa6,
  ImgSedeArequipa7,
  ImgSedeArequipa8,
  ImgSedeChorrillos1,
  ImgSedeChorrillos2,
  ImgSedeChorrillos3,
  ImgSedeChorrillos4,
  ImgSedeChorrillos5,
  ImgSedeSalaverry1,
  ImgSedeSalaverry2,
  ImgSedeSalaverry4,
  ImgSedeSalaverry5,
  ImgSedeSedeCeande1,
  ImgSedeSedeCeande2,
  ImgSedeSedeCeande3,
  ImgSedeSedeCeande4,
  ImgSedeSedeCeande5,
  ImgSedeSedeCeande6,
  ImgSedeSedeCeande7,
  ImgSedeSedeCeande8,
  ImgSedeSedeCeande9,
  ImgSedeSedePiura1,
  ImgSedeSedePiura2,
  ImgSedeSedePiura3,
  ImgSedeSedePiura4,
  ImgSedeSedePiura5,
  ImgSedeSedePiura6,
  ImgSedeSedePiura7,
  ImgSedeSedePiura8,
  ImgSedeSedeTiza1,
  ImgSedeSedeTiza10,
  ImgSedeSedeTiza11,
  ImgSedeSedeTiza3,
  ImgSedeSedeTiza4,
  ImgSedeSedeTiza5,
  ImgSedeSedeTiza7,
  ImgSedeSedeTiza8,
  ImgSedeSedeTiza9,
} from "../images";

export const campusCircleMilitary = [
  {
    title: "Sede de Salaverry",
    images: [
      ImgOfficers2,
      ImgSedeSalaverry1,
      ImgSedeSalaverry2,
      ImgSedeSalaverry4,
      ImgSedeSalaverry5,
    ],
  },
  {
    title: "Sede de Chorrillos",
    images: [
      ImgSedeChorrillos2,
      ImgSedeChorrillos1,
      ImgSedeChorrillos3,
      ImgSedeChorrillos4,
      ImgSedeChorrillos5,
    ],
  },
  {
    title: "Ceande",
    images: [
      ImgOfficers5,
      ImgSedeSedeCeande1,
      ImgSedeSedeCeande2,
      ImgSedeSedeCeande3,
      ImgSedeSedeCeande4,
      ImgSedeSedeCeande5,
      ImgSedeSedeCeande6,
      ImgSedeSedeCeande7,
      ImgSedeSedeCeande8,
      ImgSedeSedeCeande9,
    ],
  },
  {
    title: "Playa la Tiza",
    images: [
      ImgSedeSedeTiza1,
      ImgSedeSedeTiza3,
      ImgSedeSedeTiza4,
      ImgSedeSedeTiza5,
      ImgSedeSedeTiza7,
      ImgSedeSedeTiza8,
      ImgSedeSedeTiza9,
      ImgSedeSedeTiza10,
      ImgSedeSedeTiza11,
    ],
  },
  {
    title: "Sede de Arequipa",
    images: [
      ImgSedeArequipa1,
      ImgSedeArequipa2,
      ImgSedeArequipa3,
      ImgSedeArequipa4,
      ImgSedeArequipa5,
      ImgSedeArequipa6,
      ImgSedeArequipa7,
      ImgSedeArequipa8,
    ],
  },
  {
    title: "Sede de Piura",
    images: [
      ImgOfficers6,
      ImgSedeSedePiura1,
      ImgSedeSedePiura2,
      ImgSedeSedePiura3,
      ImgSedeSedePiura4,
      ImgSedeSedePiura5,
      ImgSedeSedePiura6,
      ImgSedeSedePiura7,
      ImgSedeSedePiura8,
    ],
  },
];
